/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FileType = {
    Image: 'Image',
    Document: 'Document',
    Video: 'Video',
    Audio: 'Audio',
    Other: 'Other'
} as const;
export type FileType = typeof FileType[keyof typeof FileType];


export function instanceOfFileType(value: any): boolean {
    for (const key in FileType) {
        if (Object.prototype.hasOwnProperty.call(FileType, key)) {
            if (FileType[key as keyof typeof FileType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FileTypeFromJSON(json: any): FileType {
    return FileTypeFromJSONTyped(json, false);
}

export function FileTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileType {
    return json as FileType;
}

export function FileTypeToJSON(value?: FileType | null): any {
    return value as any;
}

export function FileTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FileType {
    return value as FileType;
}

